import { useMemo } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router/dom";
import { queryClient } from "@/lib/query-client";
import { useThemeStore } from "@/components/main/stores/themeStore";
import { WindowContextProvider } from "@/components/hooks/Window";
import { AuthProvider } from "@/contexts/AuthProvider";
import { router } from "@/app/router";

export function App() {
  const theme = useThemeStore((state) => state.theme);
  const muiTheme = useMemo(
    () =>
      createTheme({
        palette: { mode: theme },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: "none",
                backgroundColor: "var(--color-bg-subtle)",
              },
            },
          },
        },
      }),
    [theme],
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={muiTheme}>
        <WindowContextProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </WindowContextProvider>
      </ThemeProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
